<style lang="less">
    .allocationRecord{
        border: 1px solid #d7dde4;
        background: #efefef;
        height: 100%;
        position: relative;
        .head{
            height: 46px;
            padding-top: 10px;
            margin-bottom: 20px;
            h1{
                display: inline;
                margin-left: 20px;
                };
            .searchArea{
                display: inline-block;
                margin-left: 20px;
            }
        }
        .layout-breadcrumb{
            padding: 10px 15px 0px ;
            /*border-bottom: 1px solid #e3e3e3;*/
        }
        .layout-content{
            min-height: 80vh;
            margin: 15px;
            overflow: hidden;
            background: #fff;
            border-radius: 4px;
        }
        .layout-content-main{
            padding: 10px;
        }
        .table th{
            background-color: #00c0ff;
            color: #fff;
        }
        .footer{
            margin-top: 10px;
            width: 100%;
            height: 46px;
        }

    }
    .ivu-table .demo-table-info-cell-red{
        color: #f50807;
    }
    .ivu-table .demo-table-info-cell-yellow{
        color: #f5a832;
    }
    .ivu-table .demo-table-info-cell-blue{
        color: #00c0ff;
    }



</style>
<template>
    <div class="allocationRecord">
        <Row>
            <i-col span="24">
                <div class="layout-breadcrumb">
                    <Breadcrumb>
                        <BreadcrumbItem >资产管理</BreadcrumbItem>
                        <BreadcrumbItem >调拨记录</BreadcrumbItem>
                    </Breadcrumb>
                </div>
                <div class="layout-content">
                    <div class="layout-content-main">
                        <div class="head">
                            <h1 >调拨记录</h1>
                            <div class="searchArea">
                                固定资产名称:
                                <Input  v-model="ql_name" style="display: inline-block;width: 150px;"></Input>
                                调入部门:
                                <Select v-model="department_in" clearable style="width:150px;display: inline-block">
                                    <Option v-for="item in departmentList" :value="item.name" :key="item.name">{{ item.name }}</Option>
                                </Select>
                                调出部门:
                                <Select v-model="department_out" clearable style="width:150px;display: inline-block">
                                    <Option v-for="item in departmentList" :value="item.name" :key="item.name">{{ item.name }}</Option>
                                </Select>
                                <Button type="primary" @click="search">查询</Button>

                            </div>
                        </div>
                        <Table border :columns="columns1" class="table"  :data="dataSourceList" ref="table"></Table>

                    </div>
                </div>
                <div class="footer">
                    <Page
                            class="pull-right"
                            :total="totalSize"
                            :current="page"
                            size="small"
                            show-total
                            @on-change="changePage"
                            :page-size='pageSize'
                    ></Page>
                </div>

            </i-col>

        </Row>
    </div>

</template>

<script>
    export default {
        data () {
            return {
                loadDataUrl:'manage/waterrec/weixin_list',
                percent: 0,
                username:'',
                startDate:'',
                endDate:'',
                ql_name:'',
                department_in:'',
                department_out:'',
                recordPage: {
                    current: 1,
                    pageSize: 20,
                    total: 0
                },
                totalSize:0,
                pageSize:14,
                page:1,
                dataSourceList:[],
                departmentList:[],
                columns1: [
//                    {
//                        title: '用友系统卡片编号',
//                        key: 'DataTime',
//                        align: 'center'
//                    },
                    {
                        title: '固定资产名称',
                        key: 'name',

                        align: 'center'
                    },
                    {
                        title: '调出部门',
                        key: 'out_department',
                        align: 'center'
                    },
                    {
                        title: '调入部门',
                        key: 'in_department',
                        align: 'center'
                    },
//                    {
//                        title: '所属单位',
//                        key: 'ChuShuiKou',
//                        align: 'center',
//                    },
                    {
                        title: '调拨时间',
                        key: 'transfer_time',
                        align: 'center'
                    },
                    {
                        title: '操作员',
                        key: 'username',
                        align: 'center'
                    },
//                    {
//                        title: '增加日期',
//                        key: 'ChuanZhaShi',
//                        align: 'center'
//                    },

                ],
            }

        },
        methods: {

            //设置日期
            setDate:function (type,value) {
                switch (type){
                    case 'startDate':
                        this.startDate = value ;
                        console.log(this.startDate);
                        break;
                    case 'endDate':
                        if(value == ''){
                            this.endDate = value;
                        }else {
                            let date = new Date(value);
                            date.setDate(date.getDate());
                            this.endDate = date.format("yyyy-MM-dd");
                            console.log(this.endDate);
                        }
                        break;
                }
            },
            //部门列表
            getDepartment:function () {
                var that = this;
                var params = {};
                params.data = {};
                params.token = this.getKey('token');
                params.url = '/sys/department/list';
                params.success = function(res) {
                    that.$Loading.finish();
                    console.log(res);
                    that.departmentList = res.data.result.result;
//                    that.recordPage.total = res.result.totalSize
//                    that.dataSourceList.reverse()

                }
                this.ajaxPost(params);
            },
            //查询
            search:function (page) {
                var that=this;
                var params = {};
                if(this.department_in==undefined){
                    this.department_in='';
                }
                if(this.department_out==undefined){
                    this.department_out='';
                }
                params.data = {
                    "searchValue":{in_department:that.department_in+'|#|like',out_department:that.department_out+'|#|like',name:that.ql_name+'|#|like'},
                    "order":{"_id":-1},
                    pageSize:this.pageSize,

                };
              if(page === undefined || page === "" || isNaN(page)){
                params.data.page = 1;
              }else{
                params.data.page = page;
              }
                params.token = this.getKey('token');
                params.url = '/sys/transferrecord/list';
                console.log(params.data);
                params.success = function(res) {
                    console.log(res);
                    that.$Loading.finish();
                    that.totalSize=res.data.result.totalSize;
                    that.page=res.data.result.page;
                    that.dataSourceList = res.data.result.result;
                }
                this.ajaxPost(params);
            },
            //加载数据
            loadData: function(page){
                var that = this;
                var params = {};
                page = page == '' || page == undefined?this.page:page;
                params.data = {
//                    "searchValue":{DataTime:that.startDate+' 00:00:00 |#|'+that.endDate+' 23:59:59'},
                    "order":{"_id":-1},
                    pageSize:this.pageSize,
                    page:page
                };
                if(page === undefined || page === "" || isNaN(page)){
                    params.data.page = 1;
                }else{
                    params.data.page = page;
                }
                params.token = this.getKey('token');
                params.url = '/sys/transferrecord/list';
                params.success = function(res) {
                    that.$Loading.finish();
                    console.log(res);
                    that.totalSize=res.data.result.totalSize;
                    that.page=res.data.result.page;
                    that.dataSourceList = res.data.result.result;

                }
                this.ajaxPost(params);

            },
            changePage: function(page) {
                this.search(page);
            },
        },
        mounted: function () {
//            console.log(555);
//            console.log(888);
//            this.endDate=new Date().format('yyyy-MM-dd');
//            this.startDate=new Date(new Date(this.endDate).getTime()-24*60*60*1000).format('yyyy-MM-dd');
            this.getDepartment();
            this.loadData();

        }
    }
</script>



// WEBPACK FOOTER //
// src/components/propertyMana/allocationRecord.vue